const CheckIsActionAllow = (allowedActions = [], action = '') => {
    return allowedActions?.some(i => i['action_name'] === action)
}
export default CheckIsActionAllow